import { useMemo } from "react";
import { useParams } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import ScheduleTableActions from "./components/table-action";
// import SearchField from "../../../../../../../../../components/search-field";
import { useAttendanceLocalDepartmentScheduleList } from "../../../../../../../../../../../services/api-tansquery/attendance-local/department/schedule/list";
import { useAttendanceLocalStyles } from "../../../../../../../../../styles";
import { useListTabPanelStyles } from "./styles";
import EmptyState from "../../../../../../../../../../../Components/EmptyState";
import ScheduleFormCreate from "../form/create";
import { timeformat } from "../../../../../../../../../../../utils/dateFormat";

export default function ListTabPanel() {
    const { id } = useParams<{ id: string }>();
    const { classes } = useListTabPanelStyles();
    const { classes: defaultClasses } = useAttendanceLocalStyles();
    const { data: schedules } = useAttendanceLocalDepartmentScheduleList({ setor: Number(id) });

    const isEmpty = useMemo(() => (
        (schedules?.results ?? []).length === 0
    ), [schedules]);

    return (
        <Paper elevation={3}>
            <Box className={classes.header}>
                <Box className={classes.search}>
                    {/* <SearchField placeholder="Buscar dia da semana" /> */}
                </Box>
                <ScheduleFormCreate
                    departmentId={Number(id)}
                    existingSchedules={schedules?.results ?? []}
                />
            </Box>
            <TableContainer className={defaultClasses.tableContainer}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            <TableCell className={defaultClasses.tableTH}>Dia da semana</TableCell>
                            <TableCell className={defaultClasses.tableTH}>Horário</TableCell>
                            <TableCell className={defaultClasses.tableTH}>Intervalo</TableCell>
                            <TableCell className={defaultClasses.tableTH}>Ativo</TableCell>
                            <TableCell className={defaultClasses.tableTH} />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {schedules?.results.map((schedule) => (
                            <TableRow
                                hover
                                key={`schedule-${schedule.id}`}
                                role="checkbox"
                                tabIndex={-1}
                            >
                                <TableCell className={defaultClasses.tableCell}>
                                    {schedule.dia_semana}
                                </TableCell>
                                <TableCell className={defaultClasses.tableCell}>
                                    {timeformat(schedule.hora_inicio)} às {timeformat(schedule.hora_fim)}
                                </TableCell>
                                <TableCell className={defaultClasses.tableCell}>
                                    {schedule.intervalo_hora_inicio && schedule.intervalo_hora_fim
                                        ? `${timeformat(schedule.intervalo_hora_inicio)} às ${timeformat(schedule.intervalo_hora_fim)}`
                                        : "Sem intervalo"}
                                </TableCell>
                                <TableCell className={defaultClasses.tableCell}>
                                    <Box
                                        className={`${defaultClasses.badge} ${schedule.ativo
                                            ? defaultClasses.active
                                            : defaultClasses.inactive
                                            }`}
                                    >
                                        {schedule.ativo ? "Sim" : "Não"}
                                    </Box>
                                </TableCell>
                                <TableCell align="right" className={defaultClasses.tableCell}>
                                    <ScheduleTableActions schedule={schedule} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                {isEmpty && <EmptyState message="Nenhum horário de agendamento encontrado." />}
            </TableContainer>
        </Paper>
    );
}
